module.exports = __webpack_public_path__ + "static/img/GI@2x.70ea0c93.jpg";